export default __webpack_public_path__ + "static/media/card_back_ccv.42af28f7.svg";